(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TIMEZONE = 'America/Mexico_City';

    function nowInMexico() {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
      var parts = fmt.formatToParts(new Date()).reduce(function (acc, p) {
        acc[p.type] = p.value;
        return acc;
      }, {});
      return {
        year: parseInt(parts.year, 10),
        month: parseInt(parts.month, 10),
        day: parseInt(parts.day, 10),
        hour: parseInt(parts.hour === '24' ? '0' : parts.hour, 10),
        minute: parseInt(parts.minute, 10),
        second: parseInt(parts.second, 10),
      };
    }

    function mexicoCivilToTimestamp(year, month, day, hour, minute, second) {
      var guess = Date.UTC(year, month - 1, day, hour + 6, minute, second);
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: TIMEZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
      });
      var parts = fmt.formatToParts(new Date(guess)).reduce(function (acc, p) {
        acc[p.type] = p.value; return acc;
      }, {});
      var seenHour = parseInt(parts.hour === '24' ? '0' : parts.hour, 10);
      var diffH = hour - seenHour;
      return guess + diffH * 3600000;
    }

    function getTargetTimestamp(el) {
      var mode = el.dataset.countdownMode;
      if (mode === 'end_of_day') {
        var n = nowInMexico();
        return mexicoCivilToTimestamp(n.year, n.month, n.day, 23, 59, 59);
      }
      // fixed_date_dhm, fixed_date_hms, o fixed_date_dhms
      if (mode === 'fixed_date_dhm' || mode === 'fixed_date_hms' || mode === 'fixed_date_dhms') {
        var raw = (el.dataset.fixedDate || '').trim();
        var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
        if (!m) return null;
        return mexicoCivilToTimestamp(
          parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10),
          parseInt(m[4], 10), parseInt(m[5], 10), parseInt(m[6] || '0', 10)
        );
      }
      return null;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function setExpired(el) {
      el.setAttribute('data-countdown-expired', 'true');
      var expiredEl = el.querySelector('.announcement-bar__expired');
      if (expiredEl) expiredEl.hidden = false;
    }

    // Construye el HTML del countdown según el modo
    function renderCountdownHTML(mode, days, hours, minutes, seconds) {
      // Modo Días/Horas/Minutos/Segundos
      if (mode === 'fixed_date_dhms') {
        return (
          '<span class="cd-unit"><span class="cd-num">' + pad(days) + '</span><span class="cd-lbl">DÍAS</span></span>' +
          '<span class="cd-sep">:</span>' +
          '<span class="cd-unit"><span class="cd-num">' + pad(hours) + '</span><span class="cd-lbl">HRS</span></span>' +
          '<span class="cd-sep">:</span>' +
          '<span class="cd-unit"><span class="cd-num">' + pad(minutes) + '</span><span class="cd-lbl">MIN</span></span>' +
          '<span class="cd-sep">:</span>' +
          '<span class="cd-unit"><span class="cd-num">' + pad(seconds) + '</span><span class="cd-lbl">SEG</span></span>'
        );
      }
      // Modo Días/Horas/Minutos
      if (mode === 'fixed_date_dhm') {
        return (
          '<span class="cd-unit"><span class="cd-num">' + pad(days) + '</span><span class="cd-lbl">DÍAS</span></span>' +
          '<span class="cd-sep">:</span>' +
          '<span class="cd-unit"><span class="cd-num">' + pad(hours) + '</span><span class="cd-lbl">HRS</span></span>' +
          '<span class="cd-sep">:</span>' +
          '<span class="cd-unit"><span class="cd-num">' + pad(minutes) + '</span><span class="cd-lbl">MIN</span></span>'
        );
      }
      // Modo horas/minutos/segundos (end_of_day o fixed_date_hms)
      return (
        '<span class="cd-unit"><span class="cd-num">' + pad(hours) + '</span><span class="cd-lbl">HRS</span></span>' +
        '<span class="cd-sep">:</span>' +
        '<span class="cd-unit"><span class="cd-num">' + pad(minutes) + '</span><span class="cd-lbl">MIN</span></span>' +
        '<span class="cd-sep">:</span>' +
        '<span class="cd-unit"><span class="cd-num">' + pad(seconds) + '</span><span class="cd-lbl">SEG</span></span>'
      );
    }

    function tick(el) {
      var mode = el.dataset.countdownMode;
      var target = getTargetTimestamp(el);
      if (!target) { setExpired(el); return; }

      var diff = target - Date.now();

      if (diff <= 0) {
        if (mode === 'fixed_date_dhm' || mode === 'fixed_date_hms' || mode === 'fixed_date_dhms') {
          setExpired(el);
          return;
        }
        diff = 0;
      }

      var totalSec = Math.floor(diff / 1000);
      var days, hours, minutes, seconds;

      if (mode === 'fixed_date_dhm' || mode === 'fixed_date_dhms') {
        // Descomponemos en días/horas/minutos (y segundos opcionales)
        days = Math.floor(totalSec / 86400);
        hours = Math.floor((totalSec % 86400) / 3600);
        minutes = Math.floor((totalSec % 3600) / 60);
        seconds = (mode === 'fixed_date_dhm') ? 0 : (totalSec % 60);
      } else {
        // end_of_day o fixed_date_hms: horas pueden acumular más de 24
        hours = Math.floor(totalSec / 3600);
        minutes = Math.floor((totalSec % 3600) / 60);
        seconds = totalSec % 60;
        days = 0;
      }

      var display = el.querySelector('[data-countdown-display]');
      if (display) {
        display.innerHTML = renderCountdownHTML(mode, days, hours, minutes, seconds);
      }
    }

    function init() {
      var nodes = document.querySelectorAll('.announcement-bar__message[data-countdown-mode]');
      nodes.forEach(function (el) {
        var mode = el.dataset.countdownMode;
        if (!mode || mode === 'none') return;
        tick(el);
        // Modo días/horas/min: refresca cada minuto (no necesita parpadeo de segundos)
        // Otros modos: refresca cada segundo
        var interval = (mode === 'fixed_date_dhm') ? 60000 : 1000;
        setInterval(function () { tick(el); }, interval);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
